import React from "react";
import Navigator from "./Navigator";
import CustomTranslatorProvider from "./context/CustomTranslatorProvider";
import ScrollProvider from "./context/UseContextScroll";

const App = () => {
  return (
    <CustomTranslatorProvider>
      <ScrollProvider>
        <Navigator />
      </ScrollProvider>
    </CustomTranslatorProvider>
  );
};

export default App;
